import { render } from "./FilePickerNewFolder.vue?vue&type=template&id=b3dc313c"
import script from "./FilePickerNewFolder.vue?vue&type=script&lang=js"
export * from "./FilePickerNewFolder.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/bomo-staging/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__